//@flow
import React from 'react';
import Link from '../../../components/Link';
import OfficeShell from '../../Shell/components/OfficeShell.react';

export default function OfficeReferThankYou() {
  return (
    <OfficeShell>
      <div className="office-thanks">
        <div className="text-container">
          <h1>Thanks for the referral! </h1>
          <p>We’ll reach out to them soon. In the meantime, start snacking smarter at home by checking out our online catalog.</p>

          <div className="button-cta">
            <Link to="/"><button className="cta" title="Start shopping">Start shopping</button></Link>
          </div>

        </div>
        <div className="error-footer-banner" />
      </div>
    </OfficeShell>
  );
}
